/* Display-only cleanup for GoKwik recommendation cards. No cart/price writes. */
(function () {
  var watched = new WeakSet();
  function roots() {
    var all = [document];
    document.querySelectorAll('shadow-dom-container').forEach(function (host) {
      if (host.shadowRoot) {
        all.push(host.shadowRoot);
        if (!watched.has(host.shadowRoot)) {
          watched.add(host.shadowRoot);
          observer.observe(host.shadowRoot, { childList: true, subtree: true, characterData: true });
        }
      }
    });
    return all;
  }
  function tidyRecommendations() {
    roots().forEach(function (root) {
    root.querySelectorAll('.scroll-container').forEach(function (list) {
      var seen = Object.create(null);
      list.querySelectorAll(':scope > .card').forEach(function (card) {
        var title = card.querySelector('.product-name');
        var price = card.querySelector('.price');
        var add = card.querySelector('.add-btn');
        if (!title || !price || !add) return;
        var match = price.textContent.match(/(?:₹|Rs\.?|INR)\s*([\d,]+(?:\.\d+)?)/i);
        if (!match) return;
        var amount = Number(match[1].replace(/,/g, ''));
        var img = card.querySelector('img');
        var key = title.textContent.trim() + '|' + (img ? img.getAttribute('src').split('?')[0] : '') + '|' + amount;
        var hide = amount <= 0 || !!seen[key];
        seen[key] = true;
        if (card.hidden !== hide) card.hidden = hide;
        if (hide) {
          card.style.setProperty('display', 'none', 'important');
          card.setAttribute('data-ir-hidden-recommendation', 'true');
        } else if (card.hasAttribute('data-ir-hidden-recommendation')) {
          card.style.removeProperty('display');
          card.removeAttribute('data-ir-hidden-recommendation');
        }
      });
    });
    });
  }
  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; tidyRecommendations(); });
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  tidyRecommendations();
})();
